import { QueryClient } from '@tanstack/react-query'
import { LOCAL_DATA_TTL, MAX_RETRIES } from 'consts'

export const getQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: LOCAL_DATA_TTL,
        refetchOnWindowFocus: false,
        retry: (count: number, error: any) => {
          if ([403, 404].includes(error?.response?.status)) {
            return false
          }
          return count < MAX_RETRIES
        },
      },
    },
  })
